import { createActions } from 'redux-actions';

const namespace = 'tabs';

export const TABS_REGISTER = `${namespace}/REGISTER_TABS`;
export const TABS_CHANGE = `${namespace}/CHANGE_TABS`;

export const { tabs: { registerTabs, changeTabs } } = createActions({
  [TABS_REGISTER]: [
    (_, tabsConfig) => tabsConfig,
    tabs => ({ tabs }),
  ],
  [TABS_CHANGE]: [
    (_, tab) => tab,
    tabs => ({ tabs }),
  ],
});

